/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:up", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  function initShopFollowButtons() {
    const followButtons = document.querySelectorAll("shop-follow-button");

    followButtons.forEach((followButtonComponent) => {
      const applyStyles = () => {
        const shadowRoot = followButtonComponent.shadowRoot;

        if (!shadowRoot) return;

        if (shadowRoot.querySelector("#custom-follow-style")) return;

        const customStyle = document.createElement("style");
        customStyle.id = "custom-follow-style";

        customStyle.textContent = `
              button div:first-of-type {
                background-color: #FFFFFF !important;
                border-radius: 0px !important;
                border: 2px solid #fff !important;
                transition: all 0.3s ease !important;
                left: 0 !important;
              }

              button {
                cursor: pointer !important;
                padding-left: 30px !important;
                padding-right: 30px !important;
                height: 50px !important;
              }

              button:hover svg,
              button:hover span {
                color: #71913a !important;
              }

              button:hover:after {
                filter: brightness(0) saturate(100%) invert(50%) sepia(44%) saturate(491%) hue-rotate(40deg) brightness(94%) contrast(94%);
              }

              button:after {
                content: "";
                background-image: url(https://cdn.shopify.com/s/files/1/0795/5768/9664/files/btn-white-icon.svg?v=1778652263);
                width: 10px;
                height: 10px;
                margin-left: 10px;
                display: inline-block;
                background-size: contain;
                background-repeat: no-repeat;
              }

              button span,
              button svg {
                color: #2f2f2f !important;
                font-family: Lato;
                font-weight: 500;
                font-size: 16px;
                line-height: 140%;
                text-transform: uppercase;
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
              }

              button span:after {
                content: " SHOP";
                display: inline-block !important;
                margin-left: 5px;
              }

              button span svg,
              button > div > svg {
                width: 0 !important;
              }

              button > div,
              button > span {
                padding: 0 !important;
              }
            `;

        shadowRoot.appendChild(customStyle);
      };

      // Delay helps because Shopify renders web component async
      setTimeout(applyStyles, 500);
    });
  }

  function initLooxSnippetsWidgets() {
    const LOOX_STYLE_ID = "custom-loox-snippets-style";
    const LOOX_INIT_ATTR = "data-loox-snippets-styled";

    const initLooxSnippetsWidget = (widget) => {
      if (widget.hasAttribute(LOOX_INIT_ATTR)) return;

      const injectStyles = () => {
        const shadowRoot = widget.shadowRoot;
        if (!shadowRoot) return false;
        if (shadowRoot.querySelector(`#${LOOX_STYLE_ID}`)) {
          widget.setAttribute(LOOX_INIT_ATTR, "");
          return true;
        }

        const style = document.createElement("style");
        style.id = LOOX_STYLE_ID;
        style.textContent = `
        .wrapper{
        background-color:transparent !important;
        box-shadow:none !important;
        border-radius:0 !important;
        }
   .wrapper .grid {
    display: flex !important;
    gap: 0 !important;
    align-items: stretch;
}

.wrapper .quickview-button {
    width: 33.33%;
    min-width: 33.33%;
    max-width: 33.33%;
    margin-left: 0;
    padding: 14px 0  !important;
}
.wrapper .quickview-button .element {
    padding: 0 15px;
    text-align: left;
    height: 100%;
    display: block;
}
.wrapper .grid .content {
    padding: 30px 28px;
    min-height: 125px;
    justify-content: flex-start;
    background: #FFFFFF;
    height: inherit;
    box-sizing: border-box;
    flex-direction: unset;
    flex-wrap: wrap;
    box-shadow: 2px 2px 10px 0px #00000026;
    border-bottom: 2px solid #71913A;
    border-radius: 10px;
}
 .wrapper .grid .content .title {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #EAEAEA;
    padding: 10px 0 0;
    flex-flow: row-reverse;
    order: 5;
    margin-top: auto;
}
.wrapper .grid .content .title .name {
    font-weight: 400;
    color: var(--body-text-color);
    font-size: 18px;
    line-height: 120%;
    order: 3;
    text-align: center;
    font-family: var(
    --FONT-STACK-BODY);
    opacity: 0.6;
}
   .wrapper .grid .content .rating {
    justify-content: flex-end;
    gap:5px;
}
  .wrapper .grid .content .rating svg {
    width: 16px;
    height: 16px;
    color: #FFC107;
}
 .wrapper .grid .content .text:before {
    content: "";
    width: 31px;
    height: 21px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='22' viewBox='0 0 32 22' fill='none'%3E%3Cpath d='M8.46875 1.3252C7.19242 1.91427 6.03871 2.77333 5.00781 3.90234C4.02594 4.98241 3.33904 6.13691 2.94629 7.36426C2.50451 8.73878 2.43009 10.0886 2.72461 11.4141C4.00104 9.89217 5.79321 9.13087 8.10059 9.13086C10.0643 9.13086 11.6352 9.69604 12.8135 10.8252C13.9917 11.9053 14.5811 13.452 14.5811 15.4648C14.581 17.3793 13.9424 18.9254 12.666 20.1035C11.3897 21.2326 9.7209 21.7978 7.65918 21.7979C6.38274 21.7979 5.22824 21.5766 4.19727 21.1348C3.2156 20.6439 2.42987 19.9568 1.84082 19.0732C1.34993 18.386 0.908349 17.4284 0.515625 16.2012C0.171986 14.9739 1.83936e-05 13.599 0 12.0771C0 9.62246 0.638599 7.31442 1.91504 5.1543C3.19142 2.94537 5.15496 1.22726 7.80566 0L8.46875 1.3252ZM25.4062 1.3252C24.1299 1.91426 22.9762 2.77335 21.9453 3.90234C20.9634 4.98241 20.2756 6.13691 19.8828 7.36426C19.4411 8.7387 19.3676 10.0887 19.6621 11.4141C20.9385 9.89215 22.7307 9.13086 25.0381 9.13086C27.0018 9.13087 28.5727 9.69605 29.751 10.8252C30.9292 11.9053 31.5186 13.452 31.5186 15.4648C31.5185 17.3793 30.8799 18.9254 29.6035 20.1035C28.3272 21.2326 26.6584 21.7978 24.5967 21.7979C23.3202 21.7979 22.1657 21.5766 21.1348 21.1348C20.1531 20.6439 19.3674 19.9568 18.7783 19.0732C18.2874 18.386 17.8458 17.4283 17.4531 16.2012C17.1095 14.9739 16.9375 13.599 16.9375 12.0771C16.9375 9.62246 17.5761 7.31442 18.8525 5.1543C20.1289 2.94537 22.0924 1.22726 24.7432 0L25.4062 1.3252Z' fill='%2371913A'/%3E%3C/svg%3E");
    background-size: contain;
}


.wrapper .grid .content .text {
    text-align: left;
    font-family: var(--FONT-STACK-BODY);
    font-size: 20px;
    line-height: 140%;
    color: #2f2f2f;
    margin: 0 auto 15px;
    max-width: 100%;
    -webkit-line-clamp: 3;
    width: 100%;
    position: relative;
    padding-top: 31px;
}
    button.arrow:hover{
    background: var(--main-green);
    color: #fff;
    }

    .arrow{
     width:30px !important;
     height:30px !important;
     box-shadow: none !important;
     display:inline-flex !important;
     align-items: center !important;
     justify-content: center !important;
    }

    .arrow:hover{
    background:#2f2f2f !important;
    }
    .arrow.left {
    left: -40px !important;
}
.arrow.right {
    right: -40px !important;
}
  .arrow[style="opacity: 0; --loox-snippets-left-arrow-visibility: hidden;"] , .arrow[style="opacity: 0; --loox-snippets-right-arrow-visibility: hidden;"] {
    opacity: 0.5 !important;
    pointer-events: none !important;
    visibility: visible !important;
}
@media(max-width: 1439px){
.arrow.right {
    right: -20px !important;
}
    .arrow.left {
    left: -20px !important;
}

      }
@media(max-width: 1199px){
 .wrapper .grid .content {
    padding: 20px 15px;
}
    .wrapper .grid .content .title .name {
    font-size: 14px;
 }
    .wrapper .grid .content .text {
    font-size: 16px;
 }
      }


    @media(max-width: 991px){
    .wrapper .quickview-button {
    width: 50%;
    min-width: 50%;
    max-width: 50%; 
   
}
    .arrow.right {
    right: 0px !important;
}
    .arrow.left {
    left: 0px !important;
}
    }

     @media(max-width: 767px){
     .wrapper .quickview-button {
    width: 100%;
    min-width: 100%;
    max-width: 50%;

}
    .container button.arrow {
    position: static !important;
}
    .container {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
}
 .container button.arrow {
    position: relative !important;
    transform: none;
    margin: 24px 10px 0;
    right: 0;
    left: 0;
}
    .wrapper .quickview-button .element {
    padding: 0 5px;
}
     }

        `;

        shadowRoot.appendChild(style);
        widget.setAttribute(LOOX_INIT_ATTR, "");
        return true;
      };

      if (injectStyles()) return;

      const widgetObserver = new MutationObserver(() => {
        if (injectStyles()) widgetObserver.disconnect();
      });
      widgetObserver.observe(widget, { childList: true, subtree: true });

      let attempts = 0;
      const maxAttempts = 50;
      const tryApply = () => {
        if (injectStyles()) {
          widgetObserver.disconnect();
          return;
        }
        if (++attempts < maxAttempts) setTimeout(tryApply, 300);
        else widgetObserver.disconnect();
      };

      setTimeout(tryApply, 100);
    };

    const scanLooxSnippetsWidgets = () => {
      document
        .querySelectorAll("loox-snippets-widget")
        .forEach(initLooxSnippetsWidget);
    };

    scanLooxSnippetsWidgets();

    const looxDocObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.("loox-snippets-widget"))
            initLooxSnippetsWidget(node);
          node
            .querySelectorAll?.("loox-snippets-widget")
            .forEach(initLooxSnippetsWidget);
        });
      });
    });
    looxDocObserver.observe(document.body, { childList: true, subtree: true });

    if (window.customElements?.whenDefined) {
      customElements
        .whenDefined("loox-snippets-widget")
        .then(scanLooxSnippetsWidgets)
        .catch(() => {});
    }

    document.addEventListener("shopify:section:load", scanLooxSnippetsWidgets);
    window.addEventListener("load", scanLooxSnippetsWidgets);
  }

  function initStylesLoadedState() {
    if (document.body.classList.contains("styles-loaded")) return;

    const themeCss = document.getElementById("theme-css");
    if (themeCss?.sheet) {
      document.body.classList.add("styles-loaded");
      return;
    }

    document.addEventListener(
      "theme:styles:loaded",
      () => {
        document.body.classList.add("styles-loaded");
      },
      { once: true }
    );
  }

  function initThirdPartyWidgetStyles() {
    initShopFollowButtons();
    initLooxSnippetsWidgets();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initStylesLoadedState();
      initThirdPartyWidgetStyles();
    });
  } else {
    initStylesLoadedState();
    initThirdPartyWidgetStyles();
  }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

/* EqualWeb accessibility — delayed so it does not compete with LCP / critical JS */
(function () {
  window.interdeal = {
    get sitekey() {
      return "4ded6e0e74e4c36e9fce976ff2af5d85";
    },
    get domains() {
      return {
        js: "https://cdn.equalweb.com/",
        acc: "https://access.equalweb.com/",
      };
    },
    Position: "left",
    Menulang: "EN",
    draggable: true,
    btnStyle: {
      vPosition: ["80%", "80%"],
      margin: ["0", "0"],
      scale: ["0.6", "0.5"],
      color: {
        main: "#1876c9",
        second: "#ffffff",
      },
      icon: {
        outline: true,
        outlineColor: "#ffffff",
        type: 11,
        shape: "circle",
      },
    },
  };

  function loadEqualWeb() {
    if (document.getElementById("equalweb-accessibility")) return;
    if (!window.interdeal || !window.interdeal.domains) return;

    var coreCall = document.createElement("script");
    coreCall.id = "equalweb-accessibility";
    coreCall.src = window.interdeal.domains.js + "core/5.3.1/accessibility.js";
    coreCall.defer = true;
    coreCall.integrity =
      "sha512-3qLj5jbjMQnXk+FqEdVJjUnjJBGuBTRVOwaiT0ms6mQKQcrz4nulBxl2Hsr0/PpvEqdyJsMsU1NB+Mtfzw8hxA==";
    coreCall.crossOrigin = "anonymous";
    coreCall.setAttribute("data-cfasync", true);
    (document.body || document.head).appendChild(coreCall);
  }

  function scheduleEqualWeb() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(loadEqualWeb, { timeout: 4000 });
    } else {
      setTimeout(loadEqualWeb, 2000);
    }
  }

  if (document.readyState === "complete") {
    scheduleEqualWeb();
  } else {
    window.addEventListener("load", scheduleEqualWeb, { once: true });
  }
})();


